import * as React from 'react';
import AssetsManager from '../utils/AssetsManager';

const SuccessSendModalView: React.FC<{
    onPressClose: () => void,
    mainText: string,
    subText: string,
    icon?: string,
}> = ({onPressClose, mainText, subText, icon}) => {
    const iconDefault: string = icon || '/assets/images/common/success-green-icon.svg';
    return (
        <div className="col-12 p-0">
            <div className="row mb-5">
                <div className="col text-center">
                    <img src={AssetsManager(iconDefault)}/>
                </div>
            </div>
            <div className="row mb-3 mt-3">
                <div className="col text-center">
                    <h3 className="text-raleway text-secondary-lighten-1">
                        {mainText}
                    </h3>
                </div>
            </div>
            <div className="row p-none mb-5">
                <div className="col text-center">
                    {subText}
                </div>
            </div>
            <div className="pt-3 px-0 text-right text-center">
                <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0"
                   onClick={() => onPressClose()}>Aceptar</a>
            </div>
        </div>
    );
};

export default SuccessSendModalView;